"use strict";
module.exports = {
    'v1.cart.writeAndPlaceOrder': 'pcs',
    'v1.cart.sendCartToExternalMarketplace': 'pcs',
    'v1.cart.setCartReadyInExternalMarketplace': 'pcs',
    'v1.cart.placeToOrder': 'pcs',
    'v1.cart.abandonCart': 'pcs',
    'v1.cart.copyExistingOrderToCart': 'pcs',
    'v1.cart.setCartRow': 'pcs',
    'v1.cart.setCartRowFromArticleNumber': 'pcs',
    'v1.cart.deactivate': 'pcs',
    'v1.cart.upsert': 'pcs',
    'v1.cart.upsertWhenEmpty': 'pcs',
    'v1.cart.updateWhenEmpty': 'pcs',
    'v1.cart.update': 'pcs',
    'v1.supplierConnection.setDeliveryRules': 'pcs',
    'v1.supplierConnection.writeSupplierConnection': 'pcs',
    'v1.supplierConnection.changeSupplierCustomer': 'pcs',
    'v1.supplierConnection.requestConnection': 'pcs',
    'v1.supplierConnection.deactivate': 'pcs',
    'v1.supplierConnection.activate': 'pcs',
    'v1.supplierConnection.completeConfiguration': 'pcs',
    'v1.supplierConnection.startConfiguration': 'pcs',
    'v1.supplierConnection.upsert': 'pcs',
    'v1.supplierConnection.upsertWhenEmpty': 'pcs',
    'v1.supplierConnection.updateWhenEmpty': 'pcs',
    'v1.supplierConnection.update': 'pcs',
    'v1.supplierInPCSService.upsert': 'pcs',
    'v1.supplierInPCSService.upsertWhenEmpty': 'pcs',
    'v1.supplierInPCSService.updateWhenEmpty': 'pcs',
    'v1.supplierInPCSService.update': 'pcs',
    'v1.articleInPCSService.upsert': 'pcs',
    'v1.articleInPCSService.upsertWhenEmpty': 'pcs',
    'v1.articleInPCSService.updateWhenEmpty': 'pcs',
    'v1.articleInPCSService.update': 'pcs',
    'v1.supplierCustomerInPcsService.upsert': 'pcs',
    'v1.supplierCustomerInPcsService.upsertWhenEmpty': 'pcs',
    'v1.supplierCustomerInPcsService.updateWhenEmpty': 'pcs',
    'v1.supplierCustomerInPcsService.update': 'pcs',
    'v1.procurementArticle.upsert': 'pcs',
    'v1.procurementArticle.upsertWhenEmpty': 'pcs',
    'v1.procurementArticle.updateWhenEmpty': 'pcs',
    'v1.procurementArticle.update': 'pcs',
    'v1.procurementList.deactivate': 'pcs',
    'v1.procurementList.activate': 'pcs',
    'v1.procurementList.upsert': 'pcs',
    'v1.procurementList.upsertWhenEmpty': 'pcs',
    'v1.procurementList.updateWhenEmpty': 'pcs',
    'v1.procurementList.update': 'pcs',
    'v1.customerSubUnitInPCSService.upsert': 'pcs',
    'v1.customerSubUnitInPCSService.upsertWhenEmpty': 'pcs',
    'v1.customerSubUnitInPCSService.updateWhenEmpty': 'pcs',
    'v1.customerSubUnitInPCSService.update': 'pcs',
    'v1.organizationInPCSService.upsert': 'pcs',
    'v1.organizationInPCSService.upsertWhenEmpty': 'pcs',
    'v1.organizationInPCSService.updateWhenEmpty': 'pcs',
    'v1.organizationInPCSService.update': 'pcs',
    'v1.pcsEventsource.cleanUpOldEvents': 'pcs',
    'v1.pcsEventsource.undoEvent': 'pcs',
    'v1.pcsEventsource.reEmit': 'pcs',
};
